import { useTrafficStore } from "../stores/useTrafficStore";
import { ModalShell } from "./ModalShell";

export function InfoModal() {
  const open = useTrafficStore((state) => state.infoOpen);
  const reducedMotion = useTrafficStore((state) => state.reducedMotion);
  const tier = useTrafficStore((state) => state.performanceTier);
  const setOpen = useTrafficStore((state) => state.setInfoOpen);
  const toggleReducedMotion = useTrafficStore(
    (state) => state.toggleReducedMotion,
  );

  if (!open) return null;

  return (
    <ModalShell
      eyebrow="HOW THIS WORKS"
      title="You are not stuck in traffic."
      onClose={() => setOpen(false)}
    >
      <p className="modal-lede">You are traffic.</p>
      <ol className="premise-list">
        <li>
          <span>01</span>
          <div>
            <strong>Every active visitor becomes a car.</strong>
            <p>
              In the live version, nearby cars map to real active presence
              records.
            </p>
          </div>
        </li>
        <li>
          <span>02</span>
          <div>
            <strong>The global count controls everyone’s speed.</strong>
            <p>
              Sharing the site recruits traffic. Popularity makes the road
              worse.
            </p>
          </div>
        </li>
        <li>
          <span>03</span>
          <div>
            <strong>Positions are smooth, local interpretations.</strong>
            <p>
              Identity and actions are shared—not continuous physics or
              coordinates. Nearby cards may show a coarse city and country
              derived from IP, never a street or exact point.
            </p>
          </div>
        </li>
      </ol>
      <div className="preference-row">
        <div>
          <strong>Reduced motion</strong>
          <span>Graphics tier: {tier}</span>
        </div>
        <button
          className="toggle"
          type="button"
          role="switch"
          aria-label="Reduced motion"
          aria-checked={reducedMotion}
          onClick={toggleReducedMotion}
        >
          <span />
          {reducedMotion ? "On" : "Off"}
        </button>
      </div>
      <footer className="legal-links">
        <span>Privacy and Terms arrive with launch hardening.</span>
        <strong>A Vibe Alive Studio experiment.</strong>
      </footer>
    </ModalShell>
  );
}
